var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{ref:"erp_app",attrs:{"id":"erp_app"}},[_c('FlashNotice'),_vm._v(" "),_c('HeaderComponent',{ref:"erpHeader",on:{"headerParent":_vm.openSideFeatureMenu}}),_vm._v(" "),_c('div',{staticClass:"main-body"},[_c('v-sheet',{staticClass:"flex-grow",attrs:{"elevation":"0"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }